import { createContext } from "react";

const bazarContext = createContext();

export default bazarContext;
